import { error } from '@innovyze/stylovyze/lib/actions';
import { getImageList, getImageListResolved, getImageListRejected, } from '@innovyze/stylovyze/lib/actions/images.actions';
import { getFullImageList } from '@innovyze/stylovyze/lib/services/image.service';
import { put, retry, takeLatest } from 'redux-saga/effects';
function* getImageListSaga(action) {
    try {
        const imageList = yield retry(2, 5000, getFullImageList, action.payload);
        yield put(getImageListResolved(imageList));
    }
    catch (e) {
        yield put(error('Failed to get images'));
        yield put(getImageListRejected());
    }
}
function* watchGetImagesListSaga() {
    yield takeLatest(getImageList, getImageListSaga);
}
export default [watchGetImagesListSaga()];
